import { IActionContext } from '../helpers/ActionContext';
import { CommonErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';
import { IErrorItem, MultipleItemResult } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Subscriptions } from '../resources/Subscriptions';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ContentActionNotification, MultipleResultNotificationOptions } from './ContentActionNotification';

export class DeleteSubscriptionsAction {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate', 'Subscriptions'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private Subscriptions: Subscriptions) { }

  public deleteSubscriptions(subscriptions: Set<ISubscriptionInfo>, context: IActionContext): ng.IPromise<IResult> {

    let description: string;
    if(subscriptions.size() === 1) {
      const sub = subscriptions.first();
      description = this.$translate.instant('confirmUnsubscribeSubscription', { TARGET_NAME: L10n.elideIfLong(sub.targetName) });
    } else {
      description = this.$translate.instant('confirmUnsubscribeSubscriptions', { SUBSCRIPTION_COUNT: subscriptions.size() }, L10n.Interpolations.Count);
    }

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('unsubscribe'),
      bodyText: description,
      actionName: this.$translate.instant('confirmUnsubscribeButton', { ITEM_COUNT: subscriptions.size() }, L10n.Interpolations.Count),
      isDeleteAction: true,

      action: (dialogInstance: IConfirmActionDialogInstance) => {

        return this.Subscriptions.del(subscriptions.keys()).then((result: IResult) => {

          const notification =
            MultipleResultNotificationOptions.create(
              new MultipleItemResult(subscriptions, result),
              {
                describeSuccessSummary: (successCount:number) =>
                  this.$translate.instant('deleteSubscriptionsSuccess', { ITEM_COUNT: successCount }, L10n.Interpolations.Count),

                describeErrorSummary: (errorCount:number) =>
                  this.$translate.instant('deleteSubscriptionsError', { ERROR_COUNT: errorCount }, L10n.Interpolations.Count),

                describeErrorDetail: (errorItem: IErrorItem<ISubscriptionInfo>) => {
                  return {
                    itemName: errorItem.item.subject,
                    errorMessage: this.errorMessageFor(errorItem)
                  };
                }
              });

          this.ContentActionNotification.notify(notification);

        });

      }
    }).result;

  }

  private errorMessageFor(errorItem: IErrorItem<ISubscriptionInfo>) {
    switch (errorItem.error.code) {
      case CommonErrorCode.SubscriptionNotFound:
        return this.$translate.instant('errorSubscriptionNotFound', { SUBSCRIPTION_NAME: L10n.elideIfLong(errorItem.item.subject) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('DeleteSubscriptionsAction', DeleteSubscriptionsAction);
